import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  subscription UserIsTyping($chatId: ID!) {
    userIsTyping(id: $chatId) {
      id
      userIsTyping
    }
  }
`);
